import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79749a10"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增题目")
const _hoisted_2 = { key: 2 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "删除", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("添加选项")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_MinusCircleOutlined = _resolveComponent("MinusCircleOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "试卷管理",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setVisible(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'type')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.types.find(e => e.id == text)?.name || ''), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'questionOptions')
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(text, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, _toDisplayString(item.index) + ". " + _toDisplayString(item.value) + "(" + _toDisplayString(item.score) + "分)", 1))
            }), 128))
          : _createCommentVNode("", true),
        (column.key === 'answer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "正确答案：" + _toDisplayString(record.type == 3 ? text.join('、') : text), 1))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(text ? '显示' : '隐藏'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'control')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createElementVNode("a", {
                onClick: ($event: any) => (_ctx.setVisible(true, record)),
                style: {"margin-right":"10px"}
              }, "编辑", 8, _hoisted_3),
              _createVNode(_component_a_popconfirm, {
                title: "确定删除吗？",
                onConfirm: ($event: any) => (_ctx.onDel(record))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.formState.id ? '编辑':'新增',
      onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setVisible(false))),
      confirmLoading: _ctx.loading,
      width: "700px",
      maskClosable: "false",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.formState,
          rules: _ctx.rules,
          "label-col": _ctx.labelCol,
          "wrapper-col": _ctx.wrapperCol
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              ref: "title",
              label: "题目",
              name: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.title,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.title) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "number",
              label: "编号",
              name: "number",
              extra: "请输入纯数字"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.number,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.number) = $event)),
                  type: "number",
                  placeholder: "请输入"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "type",
              label: "题目类型",
              name: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formState.type,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.type) = $event)),
                  onChange: _ctx.onTypeChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (item) => {
                      return (_openBlock(), _createBlock(_component_a_radio, {
                        value: item.id,
                        key: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onChange"])
              ]),
              _: 1
            }, 512),
            (_ctx.formState.type != 4)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  ref: "options",
                  label: "选项"
                }, {
                  default: _withCtx(() => [
                    (_ctx.formState.options.length)
                      ? (_openBlock(), _createBlock(_component_a_form_item_rest, { key: 0 }, {
                          default: _withCtx(() => [
                            (_ctx.formState.type == 3)
                              ? (_openBlock(), _createBlock(_component_a_checkbox_group, {
                                  key: 0,
                                  value: _ctx.formState.answer,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.answer) = $event)),
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formState.options, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        style: {"display":"flex","align-items":"center","margin-bottom":"10px"},
                                        key: item.id || item.key
                                      }, [
                                        _createVNode(_component_a_checkbox, {
                                          value: item.id || item.key
                                        }, null, 8, ["value"]),
                                        _createVNode(_component_a_input_group, {
                                          compact: "",
                                          style: {"margin-left":"10px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input, {
                                              value: item.index,
                                              "onUpdate:value": ($event: any) => ((item.index) = $event),
                                              style: {"width":"40px"}
                                            }, null, 8, ["value", "onUpdate:value"]),
                                            _createVNode(_component_a_input, {
                                              value: item.value,
                                              "onUpdate:value": ($event: any) => ((item.value) = $event),
                                              style: {"width":"200px"}
                                            }, null, 8, ["value", "onUpdate:value"]),
                                            _createVNode(_component_a_input_number, {
                                              value: item.score,
                                              "onUpdate:value": ($event: any) => ((item.score) = $event),
                                              style: {"width":"80px"},
                                              min: 0.1,
                                              placeholder: "分数"
                                            }, null, 8, ["value", "onUpdate:value", "min"]),
                                            _createVNode(_component_a_tooltip, { title: "删除选项" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_button, {
                                                  onClick: ($event: any) => (_ctx.removeOptions(index))
                                                }, {
                                                  icon: _withCtx(() => [
                                                    _createVNode(_component_MinusCircleOutlined)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["value"]))
                              : (_ctx.formState.type == 4)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.formState.options, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: item.id || item.key
                                    }, [
                                      _createVNode(_component_a_input_group, { compact: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: item.index,
                                            "onUpdate:value": ($event: any) => ((item.index) = $event),
                                            style: {"width":"40px"}
                                          }, null, 8, ["value", "onUpdate:value"]),
                                          _createVNode(_component_a_input, {
                                            value: item.value,
                                            "onUpdate:value": ($event: any) => ((item.value) = $event),
                                            style: {"width":"200px"}
                                          }, null, 8, ["value", "onUpdate:value"]),
                                          _createVNode(_component_a_input, {
                                            value: item.score,
                                            "onUpdate:value": ($event: any) => ((item.score) = $event),
                                            style: {"width":"80px"},
                                            type: "number",
                                            placeholder: "分数"
                                          }, null, 8, ["value", "onUpdate:value"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  }), 128))
                                : (_openBlock(), _createBlock(_component_a_radio_group, {
                                    key: 2,
                                    value: _ctx.formState.answer,
                                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.answer) = $event)),
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formState.options, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          style: {"display":"flex","align-items":"center","margin-bottom":"10px"},
                                          key: item.id || item.key
                                        }, [
                                          _createVNode(_component_a_radio, {
                                            value: item.id || item.key
                                          }, null, 8, ["value"]),
                                          _createVNode(_component_a_input_group, { compact: "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_input, {
                                                value: item.index,
                                                "onUpdate:value": ($event: any) => ((item.index) = $event),
                                                style: {"width":"40px"}
                                              }, null, 8, ["value", "onUpdate:value"]),
                                              _createVNode(_component_a_input, {
                                                value: item.value,
                                                "onUpdate:value": ($event: any) => ((item.value) = $event),
                                                style: {"width":"200px"}
                                              }, null, 8, ["value", "onUpdate:value"]),
                                              _createVNode(_component_a_input_number, {
                                                value: item.score,
                                                "onUpdate:value": ($event: any) => ((item.score) = $event),
                                                style: {"width":"80px"},
                                                min: 0.1,
                                                placeholder: "分数"
                                              }, null, 8, ["value", "onUpdate:value", "min"]),
                                              _createVNode(_component_a_tooltip, { title: "删除选项" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_button, {
                                                    onClick: ($event: any) => (_ctx.removeOptions(index))
                                                  }, {
                                                    icon: _withCtx(() => [
                                                      _createVNode(_component_MinusCircleOutlined)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["value"]))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.formState.type != 2)
                      ? (_openBlock(), _createBlock(_component_a_form_item_rest, { key: 1 }, {
                          default: _withCtx(() => [
                            (_ctx.formState.type != 4)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  onClick: _ctx.addOptions
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 512))
              : _createCommentVNode("", true),
            (_ctx.formState.type == 4)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 1,
                  ref: "answer",
                  label: "答案",
                  name: "answer",
                  help: "开放式答案可不填"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.answer,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.answer) = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 512))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, {
              ref: "status",
              label: "状态",
              name: "status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formState.status,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.status) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_a_radio, {
                      value: 1,
                      key: 1
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })),
                    (_openBlock(), _createBlock(_component_a_radio, {
                      value: 0,
                      key: 0
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "score",
              label: "分数",
              name: "score"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: _ctx.formState.score,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.score) = $event)),
                  min: 0.1,
                  placeholder: "请输入"
                }, null, 8, ["value", "min"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              "wrapper-col": { span: 14, offset: 4 },
              style: {"margin-top":"16px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.onSubmit,
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"]),
                _createVNode(_component_a_button, {
                  style: {"margin-left":"10px"},
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setVisible(false))),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "label-col", "wrapper-col"])
      ]),
      _: 1
    }, 8, ["visible", "title", "confirmLoading"])
  ], 64))
}